<div class="card" style="max-height: 70vh; overflow-y: auto;" *ngIf="students && students.length>0">

    <div class="border-0">
        <button style="float:right" class="add-item-btn" title="Export" (click)="export()"><i
                class='fas fileicons'>&#xf381;</i> Export</button>
        <!-- <h2 class="mb-0">Attendance For "{{lessondetails.title}}" on {{meetingdetails.scheduleDateTimeString}}</h2>
        <h4 class="mb-0">Total Number Of Students In Attendance: {{students.length}}</h4> -->
    </div>
    <div class="table-responsive" data-toggle="list" data-list-values='["sno","name","attendancecount"]'>
        <table class="table" id="attendance">
            <thead class="thead-light">
                <tr>
                    <th colspan="5">
                        <h2 class="mb-0">ATTENDANCE FOR "{{lessondetails.title | uppercase }}"</h2>
                    </th>
                    <th>
                        <h3 class="mb-0" style="text-align:right">DATE: {{meetingdetails.scheduleDateTimeString |
                            uppercase }}</h3>

                    </th>
                </tr>
                <!-- <tr>
                    <th colspan="6">
                    </th>
                </tr> -->
                <tr>
                    <th colspan="6">
                        <h4 class="mb-0">Total Number Of Students In Attendance: {{students.length}}</h4>
                    </th>
                </tr>
                <tr>
                    <th scope="col" class="" >S No.</th>
                    <!-- <th scope="col" class="sort" data-sort="sno">S No.</th> -->
                    <th scope="col" class="" >Name</th>
                    <th scope="col" class="" >Attendance Count</th>
                    <th scope="col"></th>
                    <th scope="col"></th>
                    <th scope="col"></th>
                </tr>
            </thead>
            <tbody class="list">
                <tr *ngFor="let student of students; let i= index;">
                    <td class="sno">
                        {{i+1}} </td>
                    <td class="name">
                        {{student.Name}} </td>
                    <td class="attendancecount">{{student.AttendanceCount}}</td>
                    <td></td>
                    <td></td>
                    <td></td>
                </tr>
            </tbody>
        </table>
    </div>
    <!-- Card footer -->
    <!-- <div class="card-footer py-4">
        <nav aria-label="...">
            <ul class="pagination justify-content-end mb-0">
                <li class="page-item disabled">
                    <a class="page-link" href="#" tabindex="-1">
                        <i class="fas fa-angle-left"></i>
                        <span class="sr-only">Previous</span>
                    </a>
                </li>
                <li class="page-item active">
                    <a class="page-link" href="#">1</a>
                </li>
                <li class="page-item">
                    <a class="page-link" href="#">2 <span class="sr-only">(current)</span></a>
                </li>
                <li class="page-item"><a class="page-link" href="#">3</a></li>
                <li class="page-item">
                    <a class="page-link" href="#">
                        <i class="fas fa-angle-right"></i>
                        <span class="sr-only">Next</span>
                    </a>
                </li>
            </ul>
        </nav>
    </div> -->
</div>